export const agent_model = {
  Codigo: null,
  Descripcion: '',
  CodigoSecundario: '',
  Activo: true,
};

export const agent_filters = {
  Descripcion: '',
  CodigoSecundario: '',
  Activo: true,
};
